import { Avatar, Space, Tag } from 'antd'
import { getColorByLetter, getColorByObjectId } from '../common/helpers';
import { DATE_FORMAT_DD_MM_YYYY, STATUS_PARTNER_INTEREST_ACCEPTED, STATUS_RECOMMENDED } from '../constants/constants';
import RightArrowIcon from './icons/RightArrowIcon';
import dayjs from 'dayjs';



interface Props {
    data: any
}
const PartnerItem = (props: Props) => {
    const { data } = props;
    return (
        <div className='flex items-center justify-between gap-x-[12px]'>
            <div className='flex items-center gap-x-[12px]'>
                <Avatar shape="square" size={'large'} style={getColorByObjectId(data?.partner?.id)}>{data?.partner?.name?.charAt(0)}</Avatar>
                <div>
                    <p className='mb-1 text-[13px] font-[500]'>{data?.partner?.name}</p>
                    {data?.recommended || data?.status === STATUS_PARTNER_INTEREST_ACCEPTED ? (
                        <Tag bordered={false} color='success' className="capitalize !rounded-[24px] text-[10px] font-[500]">{data?.status === STATUS_PARTNER_INTEREST_ACCEPTED ? "Interest Accepted" : "Recommended"}</Tag>
                    ) : (
                        <></>
                    )}

                </div>
            </div>
            <div className='flex flex-col gap-y-2 items-end'>

                <RightArrowIcon color='#667085' />
                {data?.updated_at ? (
                    <p className='text-[10px] text-gray-600 flex-1 m-0'>{data?.updated_at ? dayjs(data?.updated_at)?.format(DATE_FORMAT_DD_MM_YYYY) : ""}</p>
                ) : (
                    <></>
                )}

            </div>
        </div>
    )
}

export default PartnerItem